import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import Selector from "react-select";
const getFieldCSSClasses = (touched, errors) => {
  const classes = ["react-select"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  // if (touched && !errors) {
  //   classes.push("is-valid");
  // }
  // classes.push("f-select");
  return classes.join(" ");
};

export function ReactSelector({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  touched2,
  isClearable,
  ...props
}) {
  return (
    <>
      {label && <label>{label}</label>}
      <Selector
        inputId={field.name}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        styles={{ padding: "0px", paddingRight: "0px" }}
        {...field}
        {...props}
        isClearable={isClearable}
        textFieldProps={{
          label: "Label",
          InputLabelProps: {
            shrink: true,
          },
        }}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
